import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {createBaseQueryArgs} from './api/createBaseQueryArgs';

export const localApi = createApi({
  reducerPath: 'localApi',
  tagTypes: ['MergeSuggestions'],
  endpoints: () => ({}),
  baseQuery: fetchBaseQuery(createBaseQueryArgs('http://localhost:8399/')),
});
